/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

window.formatMoney = function(e, t) {
  "string" == typeof e && (e = e.replace(".", ""));
  var i = /\{\{\s*(\w+)\s*\}\}/
  , n = t || "${{amount}}";
  function s(e, t) {
    return null == e || e != e ? t : e
  }
  function o(e, t, i, n) {
    if (t = s(t, 2),
        i = s(i, ","),
        n = s(n, "."),
        isNaN(e) || null == e)
      return 0;
    var o = (e = (e / 100).toFixed(t)).split(".");
    return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (o[1] ? n + o[1] : "")
  }
  var a = "";
  switch (n.match(i)[1]) {
    case "amount":
      a = o(e, 2);
      break;
    case "amount_no_decimals":
      a = o(e, 0);
      break;
    case "amount_with_space_separator":
      a = o(e, 2, " ", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      a = o(e, 0, ",", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      a = o(e, 0, " ");
      break;
    case "amount_with_comma_separator":
      a = o(e, 2, ".", ",")
  }
  return -1 !== n.indexOf("with_comma_separator") ? n.replace(i, a).replace(",00", "") : n.replace(i, a).replace(".00", "")
}

document.addEventListener("variant:changed", function(e) {
  const variantData = event.detail.variant;

  const priceContainer = document.querySelector(".price-list");

  if(priceContainer) {
    if (variantData.compare_at_price) {
      const priceWithVAT = variantData.price * 1.20;
      const compareAtPriceWithVAT = variantData.compare_at_price * 1.20;

		priceContainer.innerHTML = `<span data-inc-vat="false" class="price price--highlight">${window.formatMoney(variantData.price, window.theme.moneyFormat)} <span class="vat-status">(exc. VAT)</span></span>
                <span data-inc-vat="false" class="price price--compare">${window.formatMoney(variantData.compare_at_price, window.theme.moneyFormat)} <span class="vat-status">(exc. VAT)</span></span>
              
                <span data-inc-vat="true" class="price price--highlight">${window.formatMoney(priceWithVAT, window.theme.moneyFormat)} <span class="vat-status">(inc. VAT)</span></span>
                <span data-inc-vat="true" class="price price--compare">${window.formatMoney(compareAtPriceWithVAT, window.theme.moneyFormat)} <span class="vat-status">(inc. VAT)</span></span>
              `;
    } else {
      const priceWithVAT = variantData.price * 1.20;

      priceContainer.innerHTML = `
<span data-inc-vat="false" class="price">${window.formatMoney(variantData.price, window.theme.moneyFormat)} <span class="vat-status">(exc. VAT)</span></span>
<span data-inc-vat="true" class="price">${window.formatMoney(priceWithVAT, window.theme.moneyFormat)} <span class="vat-status">(inc. VAT)</span></span>`;
    }
  }
});

function getCookie(name) {
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return match[2];
}

function changeVatSettings(vatIncluded) {
  document.querySelector('body').setAttribute('data-show-inc-vat', vatIncluded);
  
  const date = new Date(
    new Date().getTime() + 1000 * 60 * 60 * 24
  );
  document.cookie = "vat_inc=" + vatIncluded + ";expires=" + date + ";";
}

document.querySelector('select.js-vat-switcher').addEventListener('change', function() {
  changeVatSettings(this.value);
});


document.querySelectorAll('[data-vat-value]').forEach(function(vatSwitch) {
  vatSwitch.addEventListener('click', function() {
    const vatIncluded = this.getAttribute('data-vat-value');
    changeVatSettings(vatIncluded);
    document.querySelector('select.js-vat-switcher').value = vatIncluded;
  });
});



const savedVatSettings = getCookie("vat_inc");

if(savedVatSettings) {
  document.querySelector('select.js-vat-switcher').value = savedVatSettings;
  document.querySelector('body').setAttribute('data-show-inc-vat', savedVatSettings);
}

